import ShButton from '@/components/Helpers/ShButton';
import HintAndExplanation from '@/components/Common/HintAndExplanation';

// @vue/component
export default {
  name: 'AddNumberToBlacklist',

  components: {
    ShButton,
    HintAndExplanation,
  },

  data() {
    return {
      value: null,
      isValid: false,
      validationErrorMessage: null,
      errorMessageTimer: null,
    };
  },

  methods: {
    async handleAddNewElement() {
      if (!this.isValid) {
        this.__showErrorMessage('Numer musi mieć dokładnie 9 cyfr');
        return;
      }
      await this.$store.dispatch('blacklist/create', {
        value: this.value,
        type: 'number',
      });
      await this.$store.dispatch('blacklist/getList');
      this.$notify.success({
        title: 'Dodano nowy element do czarnej listy',
        message: `Dodano: ${this.value} do czarnej listy`,
        customClass: 'callmeweb-notification',
      });

      this.value = null;
    },
    validateNumberLength() {
      this.isValid = false;
      this.__hideErrorMessage();

      if (/[^0-9]/i.test(this.value)) {
        this.isValid = false;
        this.__showErrorMessage('Proszę wpisać prawidłowy numer');
      }

      if (this.value.length > 9) {
        this.isValid = false;
        this.__showErrorMessage('Numer musi mieć dokładnie 9 cyfr');
      }

      if (this.value.length === 9) {
        this.isValid = true;
      }
    },
    __showErrorMessage(message) {
      this.validationErrorMessage = message;
      if (this.errorMessageTimer !== null) {
        clearTimeout(this.errorMessageTimer);
        this.errorMessageTimer = null;
      }

      this.errorMessageTimer = setTimeout(() => {
        this.validationErrorMessage = null;
      }, 1000);
    },
    __hideErrorMessage() {
      this.validationErrorMessage = null;
      if (this.errorMessageTimer !== null) {
        clearTimeout(this.errorMessageTimer);
        this.errorMessageTimer = null;
      }
    },
  },
};
